/**
 * This object is saved to LocalStorage after successful user authentication
 * and stores information about current user
 */

const KEY = 'user.data';

export class UserData {
    userId;
    jwtToken;
    expirationToken;
    schoolId;
    userRole;

    constructor(obj) {
        this.userId = obj && obj.userId;
        this.jwtToken = obj && obj.jwtToken;
        this.expirationToken = obj && obj.expirationToken;
        this.schoolId = obj && obj.schoolId;
        this.userRole = obj && obj.userRole;
    }

    save() {
        localStorage.setItem(KEY, JSON.stringify(this));
    }

    static setUserDataToLocalStorage(userData) {
        localStorage.setItem(KEY, JSON.stringify(userData));
    }

    static getUserDataFromLocalStorage() {
        const data = localStorage.getItem(KEY);
        return data ? JSON.parse(data) : null;
    }

    static removeUserDataFromLocalStorage() {
        localStorage.removeItem(KEY);
    }
}


// WEBPACK FOOTER //
// ./src/common/auth/user-data.js